
import { getData, postData } from '../utils/api-service';
import { LOGIN, FORGET_PASS, REGISTER, RESET_PASS, RESEND_VALIDATE_EMAIL, VALIDATE_EMAIL } from '../utils/api';
import cookies from 'js-cookie';
import WashdayClientSingleton from './WashdayClientSingleton';
import { beginSessionSwitch } from './sessionSecurity';

interface LoginForm {
  identifier: string;
  password: string;
}

interface ForgotPasswordForm {
  email: string
}

interface ResetPasswordForm {
  password: string
  token: string | null
}
interface ValidateAccountEmailForm {
  userId: string
  secretCode: string
}

interface SignUpForm {
  country: string
  fiscalCountry?: string
  city: string
  name: string
  phoneNumber: string
  email: string
  password: string
  confirmPassword: string
  companyName: string
  isActive: boolean
  signupCountryContext?: {
    queryCountry?: string | null
    detectedCountry?: string | null
  }
}

export type SignupCountryIso = string;
export type SignupCountrySuggestionSource = 'ip' | 'fallback' | 'unknown';
export type SignupCountrySuggestionConfidence = 'medium' | 'low';

export interface SignupCountrySuggestion {
  countryIso: SignupCountryIso;
  source: SignupCountrySuggestionSource;
  confidence: SignupCountrySuggestionConfidence;
}

export const login = async (data: LoginForm, t = (label: string) => { }) => {
  try {
    const res = await postData(LOGIN, data, null, null, null, t);
    const storeInfo = res?.data?.data?.storeInfo;
    const resObj = {
      company: res?.data?.data?.company,
      token: res?.data?.data?.token,
      user: res?.data?.data?.user
    };
    cookies.set('token', resObj.token);
    cookies.set('userID', resObj.user?._id || '');
    cookies.set('stripeCustomerId', resObj.user?.stripeCustomerId || '');
    cookies.set('currencySymbol', storeInfo?.currencySymbol || '');
    return resObj;
  } catch (e) {
    throw e;
  }
};

export const forgotPassword = async (data: ForgotPasswordForm, t = (label: string) => { }) => {
  try {
    const res = await postData(FORGET_PASS, data, null, t('alerts.success'), null, t);
    return !!res;
  } catch (e) {
    throw e;
  }
};

export const register = async (data: SignUpForm) => {
  try {
    const res = await postData(REGISTER, data);
    return !!res;
  } catch (e) {
    throw e;
  }
};

export const resetPassword = async (data: ResetPasswordForm) => {
  try {
    const res = await postData(RESET_PASS, data);
    return !!res;
  } catch (e) {
    throw e;
  }
};

export const customersAppChangePassword = async (data: ResetPasswordForm) => {
  try {
    return await WashdayClientSingleton.getInstance().auth.customersAppChangePassword(data);
  } catch (e) {
    console.log('ERROR customersAppChangePassword', e);
    throw e;
  }
};

export const resendEmailVerificationCode = async (userId: string) => {
  try {
    const res = await getData(`${RESEND_VALIDATE_EMAIL}/${userId}`);
    if (!res || !res?.data) {
      throw 'No se ha enviado email de verificacion';
    }
    return res?.data
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const validateAccountEmail = async (values: ValidateAccountEmailForm) => {
  try {
    const res = await getData(`${VALIDATE_EMAIL}/${values.userId}/${values.secretCode}`);
    if (!res || !res?.data) {
      throw 'No se ha verificar email';
    }
    return res?.data
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};


export const pinLogin = async (data: {
  pinCode: string;
}) => {
  const token = cookies.get('token');
  const finishSwitch = beginSessionSwitch(token);
  try {
    const client = WashdayClientSingleton.getInstance();
    const response = await client.auth.pinLogin(data);
    const replacement = response.data?.data?.token;
    if (!replacement) throw new Error('Missing session switch credential');
    // Publish the credential before allowing old socket/background failures to run.
    if (cookies.get('token') !== token) throw new Error('Session changed during PIN login');
    cookies.set('token', replacement);
    finishSwitch(true);
    WashdayClientSingleton.refresh();
    return response;
  } catch (error) {
    finishSwitch(false);
    // The source may have been revoked before a lost PIN response reached this device.
    if (token && cookies.get('token') === token) {
      void WashdayClientSingleton.getInstance().axiosInstance.get('api/auth', {
        headers: { Authorization: `Bearer ${token}` }
      }).catch(() => undefined);
    }
    throw error;
  }
};

export const regularUserLogin = async (data: LoginForm) => {
  try {
    return await WashdayClientSingleton.getInstance().auth.regularUserLogin(data);
  } catch (e) {
    console.log('ERROR regularUserLogin', e);
    throw e;
  }
};

export const getSignupCountrySuggestion = async () => {
  try {
    return await WashdayClientSingleton.getInstance().auth.getSignupCountrySuggestion();
  } catch (e) {
    console.log('ERROR getSignupCountrySuggestion', e);
    throw e;
  }
};
